import {config} from './config'

export const API_BASE_URL = getApiBaseUrl()
export const getApiUrl = (path) => {
    if (/^https?:\/\//i.test(path)) return path
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${API_BASE_URL}${normalizedPath}`
}
export const getMediaUrl = path => {
    if (!path) return null
    if (/^(https?:|data:|blob:)/i.test(path)) return path
    if (path.startsWith('/api/')) return getApiUrl(path)
    const normalizedPath = path.replace(/^\/+/, '').replace(/^____l____e____x____e____r____\/+/, '')
    return getApiUrl(`____l____e____x____e____r____/${normalizedPath}`)
}
function getApiBaseUrl() {
    if (config.api.url) return config.api.url.replace(/\/+$/, '')
    return ''
}
